import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {CouponInput as Presentation} from './coupon-input'
import {CouponInputOwnProps, CouponInputRuntimeProps} from './interfaces'

const mapRuntime = ({actions: {editStep}}: DetailsPageAppProps): CouponInputRuntimeProps => ({editStep})

export * from './interfaces'
export const CouponInput = connect<CouponInputOwnProps, CouponInputRuntimeProps>(mapRuntime)(Presentation)
